import styled from 'styled-components';

export const FuturaTarjetaWrapper = styled.div`

._3sTov _35oaN{

    margin: 10px;

}

.contedor-comprobante {
    margin-bottom: 35px;
}

.futura-tarjeta-header-gold {
    background: rgb(78,69,46);
    background: linear-gradient(180deg, rgba(78,69,46,1) 0%, rgba(186,119,21,1) 100%);
    border-radius: 5px;
    margin: 0px 0 32px 0;
    height: 250px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-content: center;
    padding: 60px 60px 34px 60px;
    align-items: center;
    
}

.t-internacional-texto {
    padding-bottom: 32px;
}

.t-internacional img {
    position: relative;
    left: 30px;
}

.p-internacional {
    color: white;
    font-weight: bold;
    
}

.Card-Class{
    background: white;
    margin-bottom: 35px;
}


.p-internacional-dos {
    color: white;
}

.t-internacional .titulo {
    font-size: 1.5rem;
    line-height: 1.5;
    font-weight: bold;
    color: white;
}

.t-internacional .subtitulo {
    font-size: 0.9rem;
    color: #FFFFFF;
}

p.p-internacional-dos {
    position: relative;
    top: 34px;
    font-size: 0.8rem;
    font-weight: 500;
    max-width: 210px;
}

.t-internacional .texto {
    position: relative;
    left: 49px;
    bottom: 76px;
}


.contenedor{
    display: grid;
    justify-content: center;
    align-items: center;
}

.contenedor-gold-card {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
}


.p-mensaje {
    font-size: 0.9rem;
    margin-bottom: 8px;
    font-weight: 600;
}

.info .p-coment {
    font-size: 0.8rem;
    line-height: 17px;
    color: #333333;
}


.contenedor-goldcard .info {
    padding: 10px;
}


.card {
    margin-top: 16px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 30px;
}
.Titulo h1 {
    font-size: 1.5rem;
    margin: 20px 0px 20px 0px;
    }
    .mensaje {
        margin: 12px 0px 20px 0px;
    }

@media (max-width: 420px){
    .futura-tarjeta-header-gold {
        margin: 0px -11px -48px -11px;
        height: auto;
    }
}


@media (max-width: 426px){
    .t-internacional img {
        position: relative;
        left: 0;
        width: 294px;
    }
    .futura-tarjeta-header-gold {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto
    }

    .futura-tarjeta-header-gold .t-internacional:nth-child(2){
        text-align: center;   
    }


    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 46px;
        bottom: 76px;
    }

    .p-internacional-dos {
        text-align: left;
        padding-left: 24px;
        top: 26px !important;
    }

    .futura-tarjeta-header-gold{
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 40px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-gold-card{
        grid-template-columns: 1fr;
    }
    .contenedor-gold-card {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
    .Titulo h1 {
        font-size: 1.125rem;
        margin: 20px 0px 20px 0px;
        }
        .mensaje {
            margin: 12px 0px 20px 0px;
        }
 }


@media (max-width: 376px){
    
    .t-internacional img {
        position: inherit;
        left: 0;
        width: inherit;
    }
    .futura-tarjeta-header-gold {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 25px;
        bottom: 72px;
    }

    p.p-internacional-dos {
        text-align: left;
        padding-left: 24px;
        top: 24px;
    }

    
    .futura-tarjeta-header-gold .t-internacional:nth-child(2){
        text-align: center;   
    }
    .futura-tarjeta-header-gold{
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 20px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-gold-card{
        grid-template-columns: 1fr;
    }
    .contenedor-gold-card {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
    .Titulo h1 {
        font-size: 1.125rem;
        margin: 20px 0px 20px 0px;
        }
        .mensaje {
            margin: 12px 0px 20px 0px;
        }
 }


@media (max-width: 321px){ 

    .t-internacional img {
        position: relative;
        left: 0;
        width: inherit;
    }
    .futura-tarjeta-header-gold {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 16px;
        bottom: 82px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(2){
        text-align: center;   
    }
    .futura-tarjeta-header-gold{
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 0px;
    }
    .futura-tarjeta-header-gold .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-gold-card{
        grid-template-columns: 1fr;
    }
    .contenedor-gold-card {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: -5px;
        bottom: 74px;
        
    }
    .Titulo h1 {
        font-size: 1.125rem;
        margin: 20px 0px 20px 0px;
        }
        .mensaje {
            margin: 12px 0px 20px 0px;
        }
}

`;

export default FuturaTarjetaWrapper;